import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import get from 'lodash.get';
import { EngTranslations, SpanishTranslations } from '.././../../translations';

@Pipe({
  name: 'translate',
  pure: true,
})
export class TranslatePipe implements PipeTransform {
  translations = {
    en: EngTranslations,
    es: SpanishTranslations,
  };
  userLang = 'en';

  constructor(private router: Router) {
    const isSpanish = this.router.url.slice(0, 4) == '/es' ||
    this.router.url.slice(0, 4) == '/es/';
    this.userLang = isSpanish ? 'es' : 'en';
  }
  transform(translationKey: string, ...args: unknown[]): unknown {
    const translation = get(
      this.translations[this.userLang],
      translationKey,
      ''
    );
    return translation;
  }
}
